exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-bg[data-v-40e50c3a]{display:-webkit-box;display:-ms-flexbox;display:flex;height:560px;overflow:hidden}.dept-tree[data-v-40e50c3a]{width:260px;height:99%;overflow-y:scroll;overflow-x:hidden;padding-left:10px}.dept-tree[data-v-40e50c3a]::-webkit-scrollbar-track-piece{background:#eee}.dept-tree[data-v-40e50c3a]::-webkit-scrollbar{width:6px}.dept-tree[data-v-40e50c3a]::-webkit-scrollbar-thumb{background:#bbb;border-radius:20px}.user-list-bg[data-v-40e50c3a]{width:300px;height:99%;padding:0 10px}.title[data-v-40e50c3a]{font-weight:800}", ""]);

// exports
